type BgVariant = 'none' | 'dots' | 'lines' | 'cross'

interface BackgroundSelectorProps {
  value: BgVariant
  onChange: (v: BgVariant) => void
}

export default function BackgroundSelector({ value, onChange }: BackgroundSelectorProps) {
  return (
    <div className="flex items-center gap-2">
      <label htmlFor="background-variant" className="text-xs text-muted-foreground">Background</label>
      <select
        id="background-variant"
        className="h-8 border rounded-md bg-background px-2 text-xs"
        value={value}
        onChange={(e) => onChange(e.target.value as BgVariant)}
        name="background-variant"
      >
        <option value="none">None</option>
        <option value="dots">Dots</option>
        <option value="lines">Lines</option>
        <option value="cross">Cross</option>
      </select>
    </div>
  )
}
